exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vcp-switch{display:inline-block;position:relative;width:40px;height:16px;border-radius:8px;background-color:#fff;cursor:pointer}.vcp-switch:after{content:\"\";display:inline-block;position:absolute;top:1px;left:2px;width:14px;height:14px;border-radius:7px;background-color:#ff6060;-webkit-transition:left .2s ease-in .05s;transition:left .2s ease-in .05s}.vcp-switch.open:after{left:23px}", ""]);

// exports
